import { panel } from "../../tokens/component";
import { color as foundationColor } from "../../tokens/foundation";

const MuiCard = {
    styleOverrides: {
        root: {
            backgroundColor: panel.color.bg.body,
            border: `1px solid ${panel.color.border}`,
            borderRadius: panel.effects.radius,
            minHeight: panel.size.header.minHeight,
            boxShadow: 'none',
            '&.Panel-collapsed': {
                minHeight: 'auto',
            },
            '& .MuiListItem-root:last-child': {
                borderBottom: 'none',
            },
            '&.Panel-root .MuiListItem-root:first-of-type': {
                paddingTop: 0,
            },
            '&.Panel-root .MuiListItem-root:last-child': {
                paddingBottom: 0,
                borderBottom: 'none',
            },
        }
    },
}

const MuiCardHeader = {
    styleOverrides: {
        root: {
            backgroundColor: panel.color.bg.header,
            padding: `${panel.spacing.header.padding.y} ${panel.spacing.header.padding.x}`,
            borderBottom: `1px solid ${panel.color.border}`,
        },
        action: {
            margin: 0,
            alignSelf: 'center',
            '& .MuiIconButton-root': {
                color: panel.color.icon,
                fontSize: panel.size.icon.fontSize,
                height: panel.size.icon.containerSize,
                width: panel.size.icon.containerSize,
                borderRadius: panel.effects.iconRadius,
                '&:hover': {
                    backgroundColor: foundationColor.neutral[200],
                    boxShadow: `0 0 0 6px ${foundationColor.neutral[200]}`,
                },
            },
        },
    },

}

const MuiCardContent = {
    styleOverrides: {
        root: {
            padding: panel.spacing.body.padding.default,
            '&:last-child': {
                paddingBottom: panel.spacing.body.padding.default,
            },
        }
    }
}


const MuiCardActions = {
    styleOverrides: {
        root: {
            backgroundColor: panel.color.bg.footer,
            padding: `${panel.spacing.footer.padding.y} ${panel.spacing.footer.padding.x}`,
            borderTop: `1px solid ${panel.color.border}`,
            justifyContent: 'flex-end',
            '& .MuiButton-root': {
                height: panel.size.footerButton,
            }
        }
    }
}

export { MuiCard, MuiCardHeader, MuiCardContent, MuiCardActions };
